import colors from 'components/apps/FinanceAccounts/Charts/colors'
import { statusColors as statusColorsPurchaseInvoice } from 'containers/FinancePurchaseInvoices/static'
import { statusColors as statusColorsPurchaseOrder } from 'containers/FinancePurchaseOrders/static'
import { statusColors as statusColorsPurchaseRequest } from 'containers/FinancePurchaseRequests/static'
import { statusColors as statusColorsInvoice } from 'containers/FinanceInvoices/static'
import { statusColors as statusColorsOrder } from 'containers/FinanceOrder/static'
import { statusColors as statusColorsExpense } from 'containers/FinanceExpenses/static'

const transType = {
  EXPENSE: 1,
  PURCHASE_ORDER: 2,
  PURCHASE_INVOICE: 3,
  QUOTE: 4,
  INVOICE: 5,
  ORDER: 6,
  DELIVERY: 7,
  RETURN: 9,
  SPEND_MONEY: 11,
  RECEIVE_MONEY: 12,
  SEND_TRANSFER: 13,
  RECEIVE_TRANSFER: 14,
  EXPENSE_PAYMENT: 15,
  PURCHASE_PAYMENT: 16,
  RECEIVE_INVOICE_PAYMENT: 17,
  BANK_REVERSAL: 18,
  BANK_OPENING_BALANCE: 19,
  REGISTER_FIXED_ASSET: 20,
  BANK_MANUAL_JOURNAL: 32,
  REVERSAL: 21,
  OPENING_BALANCE: 22,
  RECEIVE_SALES_ORDER_PAYMENT: 23,
  CREDIT_MEMO_PAYMENT: 24,
  DEBIT_MEMO_PAYMENT: 25,
  BANK_CREDIT_MEMO: 26,
  BANK_DEBIT_MEMO: 27,
  PURCHASE_ORDER_PAYMENT: 28,
  PAYMENT_RECAP: 29,
  MANUAL_JOURNAL: 31,
  INVOICE_WITHOLDING: 33,
  PURCHASE_INVOICE_WITHOLDING: 34,
  SPEND_WITHOLDING: 36,
  INVOICE_PAYMENT_WITHOLDING: 37,
  PURCHASE_INVOICE_PAYMENT_WITHOLDING: 38,
  PROFORMA_ORDER_PAYMENT_WITHOLDING: 39,
  PROFORMA_PAYMENT_WITHOLDING: 40,
  CREATE_FIXED_ASSET: 41,
  INITIAL_DEPRECIATION: 42,
  DEPRECIATION: 43,
  DISPOSAL: 44,
  FIXED_ASSET_UPGRADE: 45,
  WAREHOUSE_TRANSFER: 51,
  WAREHOUSE_TRANSFER_GROUP: 58,
  STOCK_ADJUSTMENT: 52,
  PRODUCT_CONVERSION: 53,
  PRODUCT_BUNDLE: 54,
  PRODUCT_MANUFACTURE: 55,
  PRODUCT_CONVERSION_UNIT: 56,
  PRODUCTION_PLAN: 57,
  CREDIT_MEMO: 61,
  DEBIT_MEMO: 62,
  PURCHASE_QUOTE: 63,
  PURCHASE_DELIVERY: 8,
  PURCHASE_RETURN: 64,
  PURCHASE_REQUEST: 65,
  CLOSING: 71,
  CUSTOMER_BIRTHDAY_SETTING: 91,
  PROFORMA_ORDER: 97,
  PROFORMA_INVOICE: 98,
  RECEIVE_PROFORMA_INVOICE: 99,
  RECEIVE_PROFORMA_ORDER: 100,
  JOIN_PURCHASE_INVOICE: 240,
  PURCHASE_JOIN_INVOICE_PAYMENT: 241,
  JOIN_INVOICE: 250,
  RECEIVE_JOIN_INVOICE_PAYMENT: 251,
  USER: 1001,
  TRANSLATION: 1002,
  ROLE: 1003,
  OPTION: 1005,
  WAREHOUSE: 1006,
  TERM: 1007,
  TAX: 1008,
  PRODUCT: 1009,
  PRODUCT_CATEGORY: 1010,
  NUMBER: 1011,
  LAYOUT_INVOICE: 1012,
  LAYOUT_REPORT: 1022,
  LAYOUT_BARCODE: 1029,
  FIXED_ASSET: 1013,
  CONVERSION_BALANCE: 1014,
  CONTACT: 1015,
  GROUP_CONTACT: 1020,
  ACCOUNT: 1017,
  BILLING: 1019,
  BANK_STATEMENT: 1016,
  CASH_BANK: 1100,
  RECURRING_INVOICE: 1101,
  RECURRING_ORDER: 1102,
  RECURRING_PURCHASEINVOICE: 1103,
  RECURRING_PURCHASEORDER: 1104,
  RECURRING_EXPENSE: 1105,
  RECURRING_MANUALJOURNAL: 1106,
  RECURRING_CASHBANK: 1107,
  TAG: 1108,
  INVOICE_PAYMENT_CREDIT_MEMO: 81,
  PURCHASE_INVOICE_PAYMENT_DEBIT_MEMO: 82,
  UNREALIZED_GAIN: 73,
  SALES_SHIPPING_COSTS: 85,
  PURCHASE_SHIPPING_COSTS: 86,
  // transType from FE
  REPORT_SALES_PER_SALES_PERSON: 'REPORT_SALES_PER_SALES_PERSON',
  // id numerik resmi BE — dipakai gerbang approval (financeApproval[617001]/[617002]),
  // reveal status 111/112 di filter, branching modal serial, & link detail
  MATERIAL_REQUEST: 617001,
  MATERIAL_ISSUE: 617002,
  PAYMENT_CONNECT_SETTING: 1036,
  SCHEDULER_LOCK_DATE: 1042,
  COMPANY_SETTING: 1049,
  BUSINESS_FLOW_SETTING: 1050,
  LOCK_DATE_SETTING: 1051,
  ACCOUNT_MAPPING_SETTING: 1052,
  CONSOLIDATION_SETTING: 1053,
  CUSTOM_FIELD_SETTING: 1054,
  MULTI_CURRENCY_SETTING: 1055,
  SALES_PERSON_COMMISSION_SETTING: 1056,
  APPROVAL_SETTING: 1057,
  EMAIL_TEMPLATE_SETTING: 1061,
  WA_TEMPLATE_SETTING: 1062,
  DUE_REMINDER_SETTING: 1064,
  FEE_SETTING: 1073,
  MARKETPLACE_CONNECT_SETTING: 1074,
  SSO_SETTING: 1075,
  OPEN_API_SETTING: 1076,
  POS_CONNECT_SETTING: 1077,
  WITHOLDING_SETTING: 1084,
  TRANS_INVOICE_THANK_YOU: 35,
  EXPENSE_PAYMENT_WITHOLDING: 47,
  JOIN_INVOICE_PAYMENT_WITHOLDING: 252,
  PURCHASE_JOIN_INVOICE_PAYMENT_WITHOLDING: 242,
  EXPENSE_WITHOLDING: 46,
  INVOICE_THANK_YOU: 35,
  DELIVERY_RECAP: 616001,
  FLEET: 616002,
  INVOICE_RECAP: 616003,
  ZAP_ROUTE: 616004,
  CANVASSING: 616005,
  GLOBAL_SEARCH_PRODUCT: 230,
  GLOBAL_SEARCH_CONTACT: 231,
  GLOBAL_SEARCH_ACCOUNT: 232,
  TAGS: 1023,
  UNIT: 1024,
  SHIPPING_COMPANY: 1021,
  BUDGET_MANAGEMENT: 70001,
  // Untuk yang trans_type nya string akan menggunakan extra_search karena ada duplicate id
  PROFILE: 'profil',
  NOTIFICATION: 'notifikasi',
  BACKUP_DATABASE: 'backup database',
  SLACK_CONNECT: 'slack',
  DISCORD_CONNECT: 'discord',
  WEBHOOK: 'webhook',
}

const dbFormat = 'YYYY-MM-DD'
const paymentConst = {
  UNPAID: 1,
  PARTIAL: 2,
  PAID: 3,
}

const commissionType = {
  EXCESS_OVER_TARGET: 4,
}

const bankTransStatus = {
  RECONCILED: 32,
  UNRECONCILED: 31,
  VOID: 113,
  WAITING: 111,
  REJECT: 112,
}

const statusColors = [
  { id: transType.UNRECONCILED, color: '#CF2A28' },
  { id: transType.RECONCILED, color: '#11A428' },
  { id: paymentConst.UNPAID, name: 'Unpaid', color: '#CF2A28' },
  { id: paymentConst.PARTIAL, name: 'Partial', color: '#EB9234' },
  { id: paymentConst.PAID, name: 'Paid', color: '#11A428' },
  { id: bankTransStatus.VOID, name: 'Void', color: '#ADC2D0' },
]

const permissions = {
  INVOICES_ADD: 'invoices_add',
  INVOICES_EDIT: 'invoices_edit',
  INVOICES_DELETE: 'invoices_delete',
}

const productBundleType = {
  GENERAL: 0,
  PACKAGE: 1,
  MANUFACTURE: 2,
}

const everyType = {
  MONTH: 2,
  WEEK: 1,
  DAY: 3,
}

const availableTransType = [
  transType.INVOICE,
  transType.ORDER,
  transType.PURCHASE_INVOICE,
  transType.PURCHASE_ORDER,
  transType.EXPENSE,
  transType.MANUAL_JOURNAL,
  transType.CASH_BANK,
]

const fallbackImage =
  'data:image/png;base64,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'

const customColumnTypes = {
  TEXT: 1,
  NUMBER: 2,
  CURRENCY: 3,
  DATE: 4,
  OPTIONS: 5,
  CHECKLIST: 6,
}

const priceRuleTypes = {
  MIN_QT: 0,
  MIN_AMOUNT: 1,
}

// Default transaction penjualan dan pembelian
const defaultTransItem = {
  finance_account_id: undefined,
  qty: 1,
  price: 0,
  tax_id: '',
  desc: null,
  amount: 0,
  tax_manual: 0,
  discount_percent: 0,
  unit_id: undefined,
  product_units: [],
  stock: 0,
}

const productSerialNumberType = {
  UNIQUE_NUMBER: 1,
  PRODUCTION_NUMBER: 2,
}
const allowedLocales = ['en-US', 'id-ID']

const contactType = {
  1: {
    name: 'Vendor',
    color: colors[0],
  },
  2: {
    name: 'Employee',
    color: colors[2],
  },
  3: {
    name: 'Customer',
    color: colors[3],
  },
  4: {
    name: 'Other',
    color: colors[12],
  },
  5: {
    name: 'Investor',
    color: colors[14],
  },
}

// Untuk keperluan QA. Supaya tidak harus buat 100.000 data
const LIMIT_AUTOMATIC_SHOW_GRAND_TOTAL = import.meta.env.VITE_LIMIT_AUTOMATIC_SHOW_GRAND_TOTAL
  ? parseInt(import.meta.env.VITE_LIMIT_AUTOMATIC_SHOW_GRAND_TOTAL, 10)
  : 100_000

// Untuk detect dimana saja yang di disable, mengurangi kesalahan enable fiturnya kembali
const ENABLED_TAG_OWNER_ONLY = false

const PAYMENT_TYPE = {
  CASH: '94ec89a4-5c56-4fc6-b0ed-92030953d2af',
  E_WALLET: 'ed35c837-8321-4e57-ae58-d51e64c48537',
  ONLINE_DEVERY: 'd2aec07c-2eb6-4cab-9b9c-4542a3b8ff84',
  EDC: '9de6cc9e-25f4-413f-83d4-a6de6be9dc04',
  E_COMMERCE: '9d8f1d5d-bdf2-480e-95de-60c8eb0c4bff',
  OTHER: '0b688e8a-5ca6-486b-849e-583dda17aebd',
  TRANSFER_BANK: '17610b60-19cb-4ff6-b822-02d1ff19e75a',
  DEPOSIT: '92f80bd5-7592-af65-188c-a27786514cca',
}

const LOCAL_STORAGE_KEY = {
  PARAMS_REPORT_BALANCE_SHEET: 'params.report_balance_sheet',
  PARAMS_GRAPH_REPORT_BALANCE_SHEET: 'params.graph_report_balance_sheet',
  PARAMS_REPORT_CASH_FLOW: 'params.report_cash_flow',
  PARAMS_GRAPH_REPORT_CASH_FLOW: 'params.graph_report_cash_flow',
  PARAMS_REPORT_PROFIT_LOSS: 'params.report_profit_loss',
  PARAMS_GRAPH_REPORT_PROFIT_LOSS: 'params.graph_report_profit_loss',
  PARAMS_REPORT_EQUITY_MOVEMENT: 'params.report_equity_movement',
  PARAMS_GRAPH_REPORT_EQUITY_MOVEMENT: 'params.graph_report_equity_movement',
  PARAMS_REPORT_EXECUTIVE_SUMMARY: 'params.report_executive_summary',
  PARAMS_GRAPH_REPORT_EXECUTIVE_SUMMARY: 'params.graph_report_executive_summary',
  PARAMS_REPORT_RECEIVABLE_PAYABLE_PER_CONTACT: 'params.report_receivable_payable_per_contact',
  PARAMS_GRAPH_REPORT_RECEIVABLE_PAYABLE_PER_CONTACT:
    'params.graph_report_receivable_payable_per_contact',

  PARAMS_REPORT_BANK_SUMMARY: 'params.report_bank_summary',
  PARAMS_GRAPH_REPORT_BANK_SUMMARY: 'params.graph_report_bank_summary',
  PARAMS_REPORT_GENERAL_LEDGER: 'params.report_general_ledger',
  PARAMS_REPORT_SUBSIDIARY_LEDGER: 'params.report_subsidiary_ledger',
  PARAMS_REPORT_JOURNAL: 'params.report_journal',
  PARAMS_GRAPH_REPORT_JOURNAL: 'params.graph_report_journal',
  PARAMS_REPORT_TRIAL_BALANCE: 'params.report_trial_balance',
  PARAMS_GRAPH_REPORT_TRIAL_BALANCE: 'params.graph_report_trial_balance',

  PARAMS_REPORT_SALES_DETAIL: 'params.report_sales_detail',
  PARAMS_REPORT_AGED_RECEIVABLE: 'params.report_aged_receivable',
  PARAMS_REPORT_AGED_RECEIVABLE_DETAIL: 'params.report_aged_receivable_detail',
  PARAMS_REPORT_BALANCE_RECEIVABLE_TERMIN: 'params.report_balance_receivable_termin',
  PARAMS_REPORT_BALANCE_RECEIVABLE_TERMIN_DETAIL: 'params.report_balance_receivable_termin_detail',
  PARAMS_REPORT_CREDIT_MEMO: 'params.report_credit_memo',
  PARAMS_REPORT_CUSTOMER_INVOICE: 'params.report_customer_invoice',
  PARAMS_REPORT_PRODUCT_PROFITABILITY: 'params.report_product_profitability',
  PARAMS_REPORT_PROFITABILITY_PER_INVOICE: 'params.report_profitability_per_invoice',
  PARAMS_REPORT_INCOME_PER_CUSTOMER: 'params.report_income_per_customer',
  PARAMS_REPORT_SALES_PER_PRODUCT: 'params.report_sales_per_product',
  PARAMS_REPORT_ORDER_PER_PRODUCT: 'params.report_order_per_product',
  PARAMS_REPORT_RETURN_PER_PRODUCT: 'params.report_return_per_product',
  PARAMS_REPORT_PURCHASE_RETURN_PER_PRODUCT: 'params.report_purchase_return_per_product',
  PARAMS_REPORT_SALES_PER_SALES_PERSON: 'params.report_sales_per_sales_person',
  PARAMS_REPORT_SALES_DELIVERY: 'params.report_sales_delivery',
  PARAMS_REPORT_SHIPPING_COST_PER_EXPEDITION: 'params.report_shipping_cost_per_expedition',
  PARAMS_REPORT_INVOICE_PAYMENT: 'params.report_invoice_payment',
  PARAMS_REPORT_CUSTOMER_PAYMENT_RECAP: 'params.report_customer_payment_recap',
  PARAMS_REPORT_SALES_PER_PRODUCT_CATEGORY: 'params.report_sales_per_product_category',
  PARAMS_REPORT_PRODUCT_SALES_PER_CUSTOMER: 'params.report_product_sales_per_customer',
  PARAMS_REPORT_SALES_PER_PERIOD: 'params.report_sales_per_period',
  PARAMS_REPORT_SALES_PER_REGION: 'params.report_sales_per_region',
  PARAMS_REPORT_SELL_PRICE_HISTORY: 'params.report_sell_price_history',

  PARAMS_REPORT_PURCHASE_DETAIL: 'params.report_purchase_detail',
  PARAMS_REPORT_AGED_PAYABLE: 'params.report_aged_payable',
  PARAMS_REPORT_AGED_PAYABLE_DETAIL: 'params.report_aged_payable_detail',
  PARAMS_REPORT_BALANCE_PAYABLE_TERMIN: 'params.report_balance_payable_termin',
  PARAMS_REPORT_BALANCE_PAYABLE_TERMIN_DETAIL: 'params.report_balance_payable_termin_detail',
  PARAMS_REPORT_DEBIT_MEMO: 'params.report_debit_memo',
  PARAMS_REPORT_SUPPLIER_INVOICE: 'params.report_supplier_invoice',
  PARAMS_REPORT_PURCHASES_PER_PRODUCT: 'params.report_purchases_per_product',
  PARAMS_REPORT_PURCHASE_ORDER_PER_PRODUCT: 'params.report_purchase_order_per_product',
  PARAMS_REPORT_PURCHASES_PER_VENDOR: 'params.report_purchases_per_vendor',
  PARAMS_REPORT_PURCHASE_DELIVERY: 'params.report_purchase_delivery',
  PARAMS_REPORT_PURCHASE_INVOICE_PAYMENT: 'params.report_purchase_invoice_payment',
  PARAMS_REPORT_PRODUCT_PURCHASES_PER_VENDOR: 'params.report_product_purchases_per_vendor',
  PARAMS_REPORT_PURCHASES_PER_PERIOD: 'params.report_purchases_per_period',
  PARAMS_REPORT_PURCHASES_PER_REGION: 'params.report_purchases_per_region',

  PARAMS_REPORT_EXPENSE_PER_CONTACT: 'params.report_expense_per_contact',
  PARAMS_REPORT_EXPENSE_CLAIM: 'params.report_expense_claim',
  PARAMS_REPORT_EXPENSE_CLAIM_DETAIL: 'params.report_expense_claim_detail',

  PARAMS_REPORT_SALES_TAX: 'params.report_sales_tax',
  PARAMS_REPORT_WITHOLDING_TAX: 'params.report_witholding_tax',

  PARAMS_REPORT_INVENTORY_SUMMARY: 'params.report_inventory_summary',
  PARAMS_REPORT_INVENTORY_STOCK_MOVEMENT: 'params.report_inventory_stock_movement',
  PARAMS_REPORT_PRODUCT_STOCK_MOVEMENT: 'params.report_product_stock_movement',
  PARAMS_REPORT_WAREHOUSE_STOCK_SUMMARY: 'params.report_warehouse_stock_summary',
  PARAMS_REPORT_WAREHOUSE_STOCK_MOVEMENT: 'params.report_warehouse_stock_movement',
  PARAMS_REPORT_PRODUCTION: 'params.report_production',
  PARAMS_REPORT_PRODUCTION_AUDIT: 'params.report_production_audit',
  PARAMS_REPORT_INVENTORY_STOCK_ADJUSTMENT: 'params.report_inventory_stock_adjustment',
  PARAMS_REPORT_WAREHOUSE_TRANSFER: 'params.report_warehouse_transfer',
  PARAMS_REPORT_INVENTORY_TURNOVER: 'params.report_inventory_turnover',
  PARAMS_REPORT_PRODUCT_SERIAL_STOCK_MOVEMENT: 'params.report_product_serial_stock_movement',
  PARAMS_REPORT_PRODUCT_SERIAL_STOCK_MOVEMENT_EXPAND:
    'params.report_product_serial_stock_movement_expand',
  PARAMS_REPORT_INVENTORY_PRODUCT_SERIAL_STOCK_EXPAND:
    'params.report_inventory_product_serial_stock_expand',
  PARAMS_REPORT_INVENTORY_PRODUCT_SERIAL_EXPIRES_SOON:
    'params.report_inventory_product_serial_expires_soon',
  PARAMS_REPORT_INVENTORY_PRODUCT_SERIAL_EXPIRY_AGE:
    'params.report_inventory_product_serial_expiry_age',

  PARAMS_REPORT_MATERIAL_REQUEST_FULFILLMENT: 'params.report_material_request_fulfillment',
  PARAMS_REPORT_MATERIAL_USAGE_HISTORY: 'params.report_material_usage_history',
  PARAMS_REPORT_MATERIAL_USAGE_PER_PROJECT: 'params.report_material_usage_per_project',

  PARAMS_REPORT_FIXED_ASSET_SUMMARY: 'params.report_fixed_asset_summary',
  PARAMS_REPORT_FIXED_ASSET_DETAIL: 'params.report_fixed_asset_detail',
  PARAMS_REPORT_FIXED_ASSET_DISPOSAL: 'params.report_fixed_asset_disposal',

  PARAMS_REPORT_BUDGET_MANAGEMENT: 'params.report_budget_management',
  PARAMS_REPORT_BUDGET_PROFIT_LOSS: 'params.report_budget_profit_loss',

  PARAMS_REPORT_CONSOLIDATION_BALANCE_SHEET: 'params.report_consolidation_balance_sheet',
  PARAMS_REPORT_CONSOLIDATION_CASH_FLOW: 'params.report_consolidation_cash_flow',
  PARAMS_REPORT_CONSOLIDATION_PROFIT_LOSS: 'params.report_consolidation_profit_loss',
  PARAMS_REPORT_CONSOLIDATION_WORKSHEET: 'params.report_consolidation_worksheet',

  PARAMS_REPORT_POS_PAYMENT_TYPE: 'params.report_pos_payment_type',
  PARAMS_REPORT_POS_ORDER_TYPE: 'params.report_pos_order_type',
  PARAMS_REPORT_POS_SALES_PRICE_RULE: 'params.report_pos_sales_price_rule',

  PARAMS_REPORT_ATTACHMENT: 'params.report_attachment',
  PARAMS_REPORT_DUTY_STAMP: 'params.report_duty_stamp',
  PARAMS_REPORT_TEAM_ACTIVITIES: 'params.report_team_activities',
  PARAMS_REPORT_PAYMENT_CONNECT_KLEDO_DISBURSEMENT:
    'params.report_payment_connect_kledo_disbursement',
  PARAMS_REPORT_PAYMENT_CONNECT_KLEDO_TRANSACTION:
    'params.report_payment_connect_kledo_transaction',

  PARAMS_BANKS_DETAIL_GRAPH_BANK_BALANCE: 'params.banks_detail_graph_bank_balance',
  PARAMS_BANKS_DETAIL_GRAPH_CASH_IN: 'params.banks_detail_graph_cash_in',
  PARAMS_BANKS_DETAIL_GRAPH_CASH_OUT: 'params.banks_detail_graph_cash_out',
  PARAMS_BANKS_DETAIL_GRAPH_NET_CASH: 'params.banks_detail_graph_net_cash',
  PARAMS_BANKS_DETAIL_TRANSACTIONS: 'params.banks_detail_transactions',
  PARAMS_BANKS_DETAIL_BANK_STATEMENTS: 'params.banks_detail_bank_statements',
  PARAMS_BANKS_DETAIL_RECONCILE: 'params.banks_detail_reconcile',
  PARAMS_BANKS_DETAIL_RECURRING: 'params.banks_detail_recurring',
  PARAMS_BANKS_DETAIL_VOID: 'params.banks_detail_void',
  PARAMS_BANKS_DETAIL_WAITING_APPROVAL: 'params.banks_detail_waiting_approval',
  PARAMS_BANKS_DETAIL_REJECTED: 'params.banks_detail_rejected',
}

const DUMMY_COMPANY_ID = 1376

const STATUS_CONST_BY_TRANS_TYPE_ID = {
  [transType.EXPENSE]: {
    name: 'expense_status',
    colors: statusColorsExpense,
  },
  [transType.PURCHASE_ORDER]: {
    name: 'purchaseorder_status',
    colors: statusColorsPurchaseOrder,
  },
  [transType.PURCHASE_REQUEST]: {
    name: 'purchaserequest_status',
    colors: statusColorsPurchaseRequest,
  },
  [transType.PURCHASE_INVOICE]: {
    name: 'purchaseinvoice_status',
    colors: statusColorsPurchaseInvoice,
  },
  [transType.INVOICE]: {
    name: 'invoice_status',
    colors: statusColorsInvoice,
  },
  [transType.ORDER]: {
    name: 'order_status',
    colors: statusColorsOrder,
  },
  [transType.CREDIT_MEMO]: {
    name: 'credit_memo_status',
    colors: statusColors,
  },
  [transType.DEBIT_MEMO]: {
    name: 'debit_memo_status',
    colors: statusColors,
  },
}

const decimalOptions = [0, 1, 2, 3, 4, 5]
const paymentTypes = {
  CASH: 1,
  E_WALLET: 2,
  ONLINE_DELIVERY: 3,
  EDC: 4,
  E_COMMERCE: 5,
  LAINNYA: 6,
  TRANSFER_BANK: 7,
  DEPOSIT: 8,
  QRIS: 9,
}

const discountTypes = {
  PERCENT: 1,
  AMOUNT: 2,
}

const additionalDiscountTypes = {
  PERCENT: 1,
  AMOUNT: 2,
}

const POS_ORDER_TYPE = {
  OTHERS: -1,
  TABLE: 1,
  FREE_TABLE: 2,
  WRAP: 3,
  SERVICE: 4,
  DELIVERY: 5,
  ONLINE_MOTORCYCLE_TAXI: 6,
  RESERVATION: 7,
  SERVED_BY: 8,
}

// Array preset warna dari antd Tag
const tagColors = [
  'blue',
  'green',
  'orange',
  'red',
  'purple',
  'cyan',
  'magenta',
  'volcano',
  'gold',
  'lime',
  'geekblue',
  'processing',
]

// Fungsi untuk mendapatkan warna berdasarkan index
const getColorByIndex = (index) => {
  return tagColors[index % tagColors.length]
}

const PRODUCT_VARIANT_TYPE = {
  NOT_VARIANT: 0,
  MAIN: 1,
  CHILDREN: 2,
}
const labelToBankTrans = [
  transType.SPEND_MONEY,
  transType.SEND_TRANSFER,
  transType.PURCHASE_PAYMENT,
  transType.PURCHASE_JOIN_INVOICE_PAYMENT,
  transType.CREDIT_MEMO_PAYMENT,
  transType.DEBIT_MEMO_PAYMENT,
  transType.PURCHASE_ORDER_PAYMENT,
  transType.BANK_DEBIT_MEMO,
  transType.BANK_CREDIT_MEMO,
]
const labelFromBankTrans = [
  transType.RECEIVE_MONEY,
  transType.RECEIVE_TRANSFER,
  transType.RECEIVE_INVOICE_PAYMENT,
  transType.RECEIVE_JOIN_INVOICE_PAYMENT,
  transType.RECEIVE_SALES_ORDER_PAYMENT,
  transType.RECEIVE_PROFORMA_INVOICE,
  transType.RECEIVE_PROFORMA_ORDER,
  transType.INVOICE_WITHOLDING,
  transType.PURCHASE_INVOICE_WITHOLDING,
  transType.INVOICE_PAYMENT_WITHOLDING,
  transType.PURCHASE_INVOICE_PAYMENT_WITHOLDING,
  transType.PROFORMA_ORDER_PAYMENT_WITHOLDING,
  transType.PROFORMA_PAYMENT_WITHOLDING,
  transType.EXPENSE_PAYMENT_WITHOLDING,
  transType.JOIN_INVOICE_PAYMENT_WITHOLDING,
  transType.PURCHASE_INVOICE_PAYMENT_WITHOLDING,
]

// Tipe transaksi yang tanggalnya bermakna tanggal pembayaran, bukan tanggal transaksi
const paymentTransTypes = [
  transType.EXPENSE_PAYMENT,
  transType.PURCHASE_PAYMENT,
  transType.RECEIVE_INVOICE_PAYMENT,
  transType.CREDIT_MEMO_PAYMENT,
  transType.DEBIT_MEMO_PAYMENT,
  transType.RECEIVE_SALES_ORDER_PAYMENT,
  transType.PURCHASE_ORDER_PAYMENT,
  transType.RECEIVE_JOIN_INVOICE_PAYMENT,
  transType.PURCHASE_JOIN_INVOICE_PAYMENT,
  transType.RECEIVE_PROFORMA_ORDER,
  transType.RECEIVE_PROFORMA_INVOICE,
  transType.PAYMENT_RECAP,
  transType.INVOICE_PAYMENT_WITHOLDING,
  transType.PURCHASE_INVOICE_PAYMENT_WITHOLDING,
  transType.EXPENSE_PAYMENT_WITHOLDING,
  transType.JOIN_INVOICE_PAYMENT_WITHOLDING,
  transType.PURCHASE_JOIN_INVOICE_PAYMENT_WITHOLDING,
]

// Untuk experimental use_browsershot ke internal website_id
const experimentalWebsiteIdBrowsershot = [
  // Batik benang raja -> Dev Kledo
  1376,
  // Juragan snack -> Harmi
  89954,
  // Harmi Pro Trial -> Harmi
  206511,
  // PT Champion Prameswari -> Echa
  165615,
]

const returnPosReasonType = {
  CANCEL_ORDER: 1,
  WRONG_PROCESS: 2,
  OTHER: 3,
}

const returnPosRefundMethod = {
  CASH: 1,
  NON_CASH: 2,
}

const BILLING_ID = {
  FREE: 1,
  PRO_FREE_TRIAL: 3,
  ELITE_FREE_TRIAL: 4,
  CHAMPION_FREE_TRIAL: 7,
}

const V2_LAYOUT_TRANSACTION = false
const PROVIDER_ID = {
  MIDTRANS: 1,
  XENDIT: 2,
  DOKU: 3,
  KLEDO: 4,
}

const ZAP_ROLES = {
  DRIVER: 1,
  SALES: 2,
  CANVASSER: 3,
  SUPERVISOR: 4,
}

const BILLING_PLAN_ID = {
  FREE: 1,
  PRO: 2,
  PRO_TRIAL: 3,
  CHAMPION_TRIAL: 7,
  CHAMPION: 8,
}

const PRODUCT_VARIANT_MAX_OPTIONS = { ELITE: 40, CHAMPION: 70 }

const DELIVERY_RECAP_STATUS_ID = {
  OPEN: 1,
  ON_DELIVERY: 2,
  COMPLETE: 3,
}

const DELIVERY_RECAP_STATUS_COLOR = {
  [DELIVERY_RECAP_STATUS_ID.OPEN]: '#13A4FF',
  [DELIVERY_RECAP_STATUS_ID.ON_DELIVERY]: '#EB9234',
  [DELIVERY_RECAP_STATUS_ID.COMPLETE]: '#11A428',
}

/** Canvassing list status ids (config: canvassing_status) — Draft, Aktif, Stok Terkunci, Berlangsung, Stock Dikembalikan, Selesai */
const CANVASSING_STATUS_ID = {
  DRAFT: 1,
  ACTIVE: 2,
  STOCK_LOCKED: 3,
  IN_PROGRESS: 4,
  STOCK_RETURNED: 5,
  COMPLETED: 6,
}

const CANVASSING_STATUS_COLOR = {
  [CANVASSING_STATUS_ID.DRAFT]: '#8c8c8c',
  [CANVASSING_STATUS_ID.ACTIVE]: '#13A4FF',
  [CANVASSING_STATUS_ID.STOCK_LOCKED]: '#faad14',
  [CANVASSING_STATUS_ID.IN_PROGRESS]: '#722ed1',
  [CANVASSING_STATUS_ID.STOCK_RETURNED]: '#ff4d4f',
  [CANVASSING_STATUS_ID.COMPLETED]: '#11A428',
}

const LAT_REGEX = /^-?([0-8]?[0-9]|90)\.([0-9]{1,6})$/
const LNG_REGEX = /^-?([0-9]{1,3}|1[0-7][0-9]|180)\.([0-9]{1,6})$/

const INVOICE_RECAP_STATUS_ID = {
  OPEN: 1,
  COMPLETED: 2,
}

const INVOICE_RECAP_STATUS_COLOR = {
  [INVOICE_RECAP_STATUS_ID.OPEN]: '#CF2A28',
  [INVOICE_RECAP_STATUS_ID.COMPLETED]: '#11A428',
}

const GLOBAL_SEARCH_TYPE = {
  [transType.GLOBAL_SEARCH_PRODUCT]: 'products',
  [transType.GLOBAL_SEARCH_CONTACT]: 'contacts',
  [transType.GLOBAL_SEARCH_ACCOUNT]: 'accounts',
}

const POS_ONLINE_HEADER = { headers: { 'x-module': 'pos-online' } }

const APPROVAL_STATUS_ID = {
  WAITING_APPROVAL: 111,
  APPROVED: 112,
  REJECTED: 113,
}

const MARKETPLACE_TYPE = {
  SHOPEE: 'shopee',
  TIKTOK: 'tiktok',
}

const MARKETPLACE_COLORS = {
  shopee: 'orange',
  tiktok: 'default',
}

const MARKETPLACE_LOGO = {
  shopee: '/resources/images/marketplace/shopee-icon.svg',
  tiktok: {
    light: '/resources/images/marketplace/tiktok-shop-icon.svg',
    dark: '/resources/images/marketplace/tiktok-shop-white.svg',
  },
  lazada: '/resources/images/marketplace/lazada.svg',
  lazada_erp: '/resources/images/marketplace/lazada.svg',
}

const getMarketplaceLogoSrc = (marketplace, isDarkMode) => {
  const logo = MARKETPLACE_LOGO[marketplace]
  if (!logo) {
    return null
  }
  if (typeof logo === 'object') {
    return isDarkMode ? logo.dark : logo.light
  }
  return logo
}

const LAZADA_SERVICE_MARKETPLACE_URL =
  'https://marketplace.lazada.co.id/web/detail.html?articleCode=FW_GOODS-1000035258'
const LAZADA_CALLBACK_PATH = '/marketplace-connect/lazada/callback'

const MATERIAL_REQUEST_STATUS_ID = {
  DRAFT: 1,
  SUBMITTED: 2,
  PROCESSING: 3,
  PARTIAL_FULFILLED: 4,
  FULLY_FULFILLED: 5,
  REJECTED: 6,
  CANCELLED: 7,
}

const MATERIAL_REQUEST_STATUS = {
  [MATERIAL_REQUEST_STATUS_ID.DRAFT]: {
    messageId: 'report.material_request_status_draft',
    color: 'default',
  },
  [MATERIAL_REQUEST_STATUS_ID.SUBMITTED]: {
    messageId: 'report.material_request_status_submitted',
    color: 'blue',
  },
  [MATERIAL_REQUEST_STATUS_ID.PROCESSING]: {
    messageId: 'report.material_request_status_processing',
    color: 'cyan',
  },
  [MATERIAL_REQUEST_STATUS_ID.PARTIAL_FULFILLED]: {
    messageId: 'report.material_request_status_partial_fulfilled',
    color: 'gold',
  },
  [MATERIAL_REQUEST_STATUS_ID.FULLY_FULFILLED]: {
    messageId: 'report.material_request_status_fully_fulfilled',
    color: 'green',
  },
  [MATERIAL_REQUEST_STATUS_ID.REJECTED]: {
    messageId: 'report.material_request_status_rejected',
    color: 'red',
  },
  [MATERIAL_REQUEST_STATUS_ID.CANCELLED]: {
    messageId: 'report.material_request_status_cancelled',
    color: 'default',
  },
}

const PRODUCTION_PLAN_STATUS_ID = {
  NOT_STARTED: 1,
  PARTIAL: 2,
  COMPLETED: 3,
}

// `color` berisi nama palet preset antd untuk ToneTag. null = tag default abu-abu.
const PRODUCTION_PLAN_STATUS = [
  {
    id: PRODUCTION_PLAN_STATUS_ID.NOT_STARTED,
    labelId: 'productionPlan.status_not_started',
    color: null,
  },
  {
    id: PRODUCTION_PLAN_STATUS_ID.PARTIAL,
    labelId: 'productionPlan.status_partial',
    color: 'orange',
  },
  {
    id: PRODUCTION_PLAN_STATUS_ID.COMPLETED,
    labelId: 'productionPlan.status_completed',
    color: 'green',
  },
]

const PRODUCTION_PLAN_STOCK_STATUS_ID = {
  ENOUGH: 1,
  SHORT: 2,
}

const PRODUCTION_PLAN_STOCK_STATUS = [
  {
    id: PRODUCTION_PLAN_STOCK_STATUS_ID.ENOUGH,
    labelId: 'productionPlan.stock_status_enough',
    color: 'green',
  },
  {
    id: PRODUCTION_PLAN_STOCK_STATUS_ID.SHORT,
    labelId: 'productionPlan.stock_status_short',
    color: 'red',
  },
]

const DELIVERY_PLAN_STATUS_ID = {
  WAITING: 1,
  PUBLISHED: 2,
  FAILED: 3,
  CANCELLED: 4,
}

const DELIVERY_PLAN_STATUS = [
  {
    id: DELIVERY_PLAN_STATUS_ID.WAITING,
    labelId: 'deliveryPlan.status_waiting',
    color: '#1677FF',
  },
  {
    id: DELIVERY_PLAN_STATUS_ID.PUBLISHED,
    labelId: 'deliveryPlan.status_published',
    color: '#11A428',
  },
  {
    id: DELIVERY_PLAN_STATUS_ID.FAILED,
    labelId: 'deliveryPlan.status_failed',
    color: '#F5222D',
  },
  {
    id: DELIVERY_PLAN_STATUS_ID.CANCELLED,
    labelId: 'deliveryPlan.status_cancelled',
    color: '#ADC2D0',
  },
]

export {
  allowedLocales,
  contactType,
  transType,
  statusColors,
  dbFormat,
  paymentConst,
  permissions,
  productBundleType,
  everyType,
  availableTransType,
  bankTransStatus,
  commissionType,
  fallbackImage,
  customColumnTypes,
  priceRuleTypes,
  defaultTransItem,
  productSerialNumberType,
  LIMIT_AUTOMATIC_SHOW_GRAND_TOTAL,
  PAYMENT_TYPE,
  ENABLED_TAG_OWNER_ONLY,
  LOCAL_STORAGE_KEY,
  DUMMY_COMPANY_ID,
  STATUS_CONST_BY_TRANS_TYPE_ID,
  decimalOptions,
  paymentTypes,
  additionalDiscountTypes,
  discountTypes,
  POS_ORDER_TYPE,
  tagColors,
  getColorByIndex,
  PRODUCT_VARIANT_TYPE,
  labelToBankTrans,
  labelFromBankTrans,
  paymentTransTypes,
  experimentalWebsiteIdBrowsershot,
  returnPosReasonType,
  returnPosRefundMethod,
  BILLING_ID,
  V2_LAYOUT_TRANSACTION,
  PROVIDER_ID,
  ZAP_ROLES,
  BILLING_PLAN_ID,
  PRODUCT_VARIANT_MAX_OPTIONS,
  DELIVERY_RECAP_STATUS_ID,
  DELIVERY_RECAP_STATUS_COLOR,
  CANVASSING_STATUS_ID,
  CANVASSING_STATUS_COLOR,
  LAT_REGEX,
  LNG_REGEX,
  INVOICE_RECAP_STATUS_ID,
  INVOICE_RECAP_STATUS_COLOR,
  GLOBAL_SEARCH_TYPE,
  POS_ONLINE_HEADER,
  APPROVAL_STATUS_ID,
  MARKETPLACE_TYPE,
  MARKETPLACE_COLORS,
  MARKETPLACE_LOGO,
  getMarketplaceLogoSrc,
  LAZADA_SERVICE_MARKETPLACE_URL,
  LAZADA_CALLBACK_PATH,
  MATERIAL_REQUEST_STATUS,
  PRODUCTION_PLAN_STATUS_ID,
  PRODUCTION_PLAN_STATUS,
  PRODUCTION_PLAN_STOCK_STATUS_ID,
  PRODUCTION_PLAN_STOCK_STATUS,
  DELIVERY_PLAN_STATUS_ID,
  DELIVERY_PLAN_STATUS,
}
